<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop">
        <div class="bg-white pb-8">
          <!-- Header -->
          <div class="relative pb-24 bg-gray-800">
            <div class="absolute inset-0">
              <img
                class="w-full h-full object-cover"
                src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                alt=""
              />
              <div
                class="absolute inset-0 bg-gray-800 mix-blend-multiply"
                aria-hidden="true"
              ></div>
            </div>
            <div
              class="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8"
            >
              <h1
                class="text-4xl font-extrabold tracking-tight text-white md:text-5xl lg:text-6xl"
              >
                Documents Management
              </h1>
              <p class="max-w-3xl text-xl text-gray-300">
                Update - Create - Assign - Delete
              </p>

              <button
                @click="modalDoc('document')"
                type="button"
                class="cols-span-6 inline-flex items-center px-3 py-2 shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
              >
                <i class="-ml-0.5 mr-2 h-4 w-4  far fa-file-pdf"></i>
                Upload Document
              </button>

              <button
                type="button"
                @click="modalDoc('group')"
                class="m-1 inline-flex items-center px-3 py-2 shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
              >
                <i class="-ml-0.5 mr-2 h-4 w-4 fas fa-plus"></i>
                Create Form Group
              </button>

              <button
                type="button"
                @click="modalDoc('menu')"
                class="m-1 inline-flex items-center px-3 py-2 shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-pink-600 hover:bg-pink-700 focus:outline-none"
              >
                <i class="-ml-0.5 mr-2 h-4 w-4 fas fa-plus"></i>
                Create Nav Menu
              </button>

              <button
                @click="goto('div1')"
                type="button"
                class="m-1 inline-flex items-center px-3 py-2 shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none"
              >
                <i class="-ml-0.5 mr-2 h-4 w-4 fas fas fa-border-all"></i>
                All Documents
              </button>
            </div>
          </div>

          <section
            class="-mt-32 max-w-7xl mx-auto relative z-10 pb-32 px-4 sm:px-6 lg:px-8"
            aria-labelledby="contact-heading"
          >
            <div
              class="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8"
            >
              <div
                v-for="item in groups"
                :key="item.id"
                class="flex flex-col bg-white rounded-2xl shadow-xl p-1"
              >
                <div class="flex-1 relative pt-16 px-6 pb-8 md:px-8">
                  <div
                    class="absolute top-0 p-3 inline-block bg-white rounded-xl shadow-lg transform -translate-y-1/2"
                  >
                    <img
                      v-if="item.name === 'Management'"
                      class="h-12 w-12 text-white object-cover"
                      src="../../assets/state.png"
                      alt=""
                    />
                    <img
                      v-else-if="item.name === 'Buyer'"
                      class="h-12 w-12 text-white object-cover"
                      src="../../assets/rental.png"
                      alt=""
                    />
                    <img
                      v-else
                      class="h-12 w-12 text-white object-cover"
                      src="../../assets/bank.png"
                      alt=""
                    />
                  </div>
                  <h3 class="text-xl font-medium text-gray-900">
                    {{ item.name }}
                  </h3>
                  <div
                    v-if="item.documents.length > 0"
                    class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-3"
                  >
                    <span
                      v-for="form in item.documents"
                      :key="form.id"
                      class="inline-flex items-center py-0.5 pl-2 pr-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800"
                    >
                      <span class="truncate">{{ form.name }} </span>
                      <button
                        @click="formDeleted(item, form)"
                        type="button"
                        class="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center text-indigo-400 hover:bg-indigo-200 hover:text-indigo-500 focus:outline-none focus:bg-indigo-500 focus:text-white"
                      >
                        <svg
                          class="h-2 w-2"
                          stroke="currentColor"
                          fill="none"
                          viewBox="0 0 8 8"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-width="1.5"
                            d="M1 1l6 6m0-6L1 7"
                          />
                        </svg>
                      </button>
                    </span>
                  </div>
                  <p v-else class="mt-4 text-base text-gray-500">
                    Varius facilisi mauris sed sit. Non sed et duis dui leo,
                    vulputate id malesuada non. Cras aliquet purus dui laoreet
                    diam sed lacus, fames.
                  </p>
                </div>
                <div
                  class="p-6 bg-gray-100 rounded-bl-2xl rounded-br-2xl md:px-8 text-right"
                >
                  <button
                    @click="openModal(item)"
                    type="button"
                    class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none"
                  >
                    Add Forms
                  </button>

                  <button
                    type="button"
                    @click="removeGroup(item)"
                    class="ml-2 inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-full shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </section>

          <div class="bg-gray-900">
            <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
              <div class="text-center">
                <h2
                  class="text-base font-semibold text-indigo-600 tracking-wide uppercase"
                >
                  Manage
                </h2>
                <p
                  class="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight lg:text-6xl"
                >
                  All Documents
                </p>
                <div class="text-gray-600 mb-2 mt-2">
                  <input
                    v-model="search"
                    type="search"
                    name="serch"
                    placeholder="Search Document"
                    class="shadow bg-white h-10 w-full px-5 pr-10 rounded-full text-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="-mt-12 flex flex-col max-w-7xl mx-auto relative"
            ref="div1"
          >
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div
                class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
              >
                <div
                  class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                >
                  <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Document #
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Groups Attached
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Menu Item
                        </th>
                        <th
                          scope="col"
                          class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                      <tr v-for="doc in docsFilter" :key="doc.id">
                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                        >
                          {{ doc.id }}
                        </td>
                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                        >
                          {{ doc.name }}
                        </td>
                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                        >
                          <v-chip
                            v-for="group in doc.groups"
                            :key="group.id"
                            small
                            close
                            @click:close="groupDeleted(doc, group)"
                            >{{ group.name }}</v-chip
                          >
                        </td>

                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                        >
                          <v-chip
                            color="light"
                            v-for="item in doc.items"
                            :key="item.id"
                            small
                            close
                            @click:close="itemDelete(doc, item)"
                            >{{ item.name }}</v-chip
                          >
                        </td>

                        <td
                          class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                        >
                          <v-btn
                            v-if="doc.json_data == null"
                            color="secondary"
                            x-small
                            rounded
                            dark
                            @click="getFillable(doc)"
                          >
                            Edit
                          </v-btn>

                          <v-btn
                            color="success"
                            class="ml-2"
                            x-small
                            rounded
                            dark
                            @click="showMenu(doc)"
                          >
                            Add Menu
                          </v-btn>

                          <v-btn
                            color="#2196F3"
                            class="ml-2"
                            target="_blank"
                            x-small
                            rounded
                            :href="url2 + doc.s3_name"
                            dark
                          >
                            Document
                          </v-btn>

                          <v-btn
                            @click="removeDoc(doc)"
                            x-small
                            rounded
                            class="ml-2"
                            color="#E53935"
                            dark
                          >
                            Delete</v-btn
                          >
                        </td>
                      </tr>

                      <!-- More people... -->
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="documentModal">
      <div
        class="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
          ></div>

          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <div
            class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
          >
            <document-modal
              :type="type"
              @update="documentModal = false"
              @close="modalDocClose"
              :items="menuItems"
            ></document-modal>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal -->
    <div
      class="modal fade bd-example-modal-lg"
      id="selectForms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content p-4">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewLabel">
              Document
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <v-select
            v-model="selectedForms"
            :items="filterDocs"
            label="Select"
            multiple
            chips
            hint="What are the target regions"
            persistent-hint
          ></v-select>

          <v-btn
            rounded
            class="mt-4"
            color="primary"
            @click="saveDocGroup(singleGroup)"
            dark
          >
            Save</v-btn
          >
        </div>
      </div>
    </div>
    <!-- close modal  -->

    <v-dialog v-model="showDialog" max-width="600">
      <div class="bg-white p-2 rounded">
        <v-select
          v-model="selectedMenu"
          :items="filterMenu"
          label="Select"
          chips
          persistent-hint
        ></v-select>

        <v-btn
          rounded
          class="mt-4"
          color="primary"
          @click="saveDocMenu(docSingle)"
          dark
        >
          Save</v-btn
        >
      </div>
    </v-dialog>

    <v-dialog
      v-if="arraySub"
      v-model="arraySub"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#424242">
          <v-btn icon dark @click="closeDialogSub()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
        </v-toolbar>

        <v-row>
          <v-col cols="12" md="6">
            <embed
              :src="url2 + submissionName.file_name"
              width="100%"
              height="100%"
            />
          </v-col>

          <v-col cols="12" md="6" class="p-4">
            <v-divider></v-divider>

            <v-form id="mySubmission">
              <div class="form-group">
                <div
                  class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                >
                  <div
                    v-for="(single, index) in arraySubmission"
                    :key="index"
                    class="sm:col-span-3"
                  >
                    <template
                      v-if="
                        single.type === 'PDFTextField' ||
                          single.type === 'PDFSignature'
                      "
                    >
                      <label
                        for="first_name"
                        class="block text-sm font-medium text-gray-600"
                      >
                        {{ single.name }}
                        <small class="ml-1 text-gray-400"
                          >({{ single.type }})</small
                        >
                      </label>

                      <input
                        type="text"
                        :name="single.name"
                        :value="single.value"
                        class="disabled:opacity-50 text-indigo-500 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md p-2"
                      />
                    </template>

                    <template v-else-if="single.type === 'PDFCheckBox'">
                      <label
                        for="checks"
                        class="block text-sm font-medium text-gray-600"
                      >
                        {{ single.name }}
                        <small class="ml-1 text-gray-400"
                          >({{ single.type }})</small
                        >
                      </label>

                      <input
                        type="checkbox"
                        :checked="single.value ? true : false"
                        :name="single.name"
                        :value="single.value"
                        class="disabled:opacity-50 block sm:text-sm border border-gray-300 rounded-md p-2"
                      />
                    </template>
                  </div>
                </div>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
import DocumentModal from "./DocumentModal.vue";
import { PDFDocument } from "pdf-lib";
export default {
  components: { DocumentModal },
  data() {
    return {
      dialog: false,
      urls3: process.env.VUE_APP_API_URL_S3,

      name: "",
      description: "",
      document: [],
      docs: [],
      singleDoc: "",
      docPdf: [],
      tooltipShow: false,

      singleValue: "",
      groupName: "",
      groups: [],
      singleGroup: "",
      selectedForms: [],
      url2: process.env.VUE_APP_API_URL_S3,
      e1: 1,
      documentModal: false,
      type: "",
      search: "",
      menuItems: [],
      docSingle: "",
      selectedMenu: [],
      showDialog: false,

      arraySubmission: [],
      arraySub: false,
      submissionName: ""
    };
  },

  computed: {
    filterDocs() {
      return this.docs.map(element => {
        return element.name;
      });
    },

    filterMenu() {
      return this.menuItems.map(element => {
        return element.name;
      });
    },

    docsFilter() {
      if (this.search == "") {
        return this.docs;
      } else {
        return this.docs.filter(doc => {
          return doc.name.toLowerCase().includes(this.search.toLowerCase());
        });
      }
    }
  },

  created() {
    this.getDocuments();
    this.getGroups();
    this.getMenuItems();
  },

  methods: {
    removeGroup(group) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          window.axios.post("/api/removeGroup/" + group.id).then(() => {
            this.getGroups();
            Swal.fire("Deleted!", "Your Group has been deleted.", "success");
          });
        }
      });
    },

    getMenuItems() {
      window.axios.get("/api/menuItems").then(response => {
        this.menuItems = response.data;
      });
    },

    saveDocGroup(singleGroup) {
      window.axios
        .post("/api/saveGroupForms/" + singleGroup.id, {
          selectedForms: this.selectedForms
        })
        .then(() => {
          this.getGroups();
          this.getDocuments();
          $("#selectForms").modal("hide");
        });
    },

    saveDocMenu(doc) {
      window.axios
        .post("/api/saveMenuDoc/" + doc.id, {
          selectedMenu: this.selectedMenu
        })
        .then(() => {
          this.getGroups();
          this.getDocuments();
          this.showDialog = false;
        });
    },

    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },

    modalDocClose() {
      console.log("armando");
      this.getMenuItems();
      this.getDocuments();
      this.getGroups();
      this.type = "";
      this.documentModal = false;
    },

    modalDoc(value) {
      this.type = value;
      this.documentModal = true;
    },
    // drag functionality
    startDrag: (evt, doc) => {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("itemID", doc.id);
    },

    onDrop(evt, list) {
      let itemID = evt.dataTransfer.getData("itemID");

      let item = this.groups[0].documents.find(item => {
        return item.id == itemID;
      });

      if (item) {
        return (this.tooltipShow = !this.tooltipShow);
      } else {
        window.axios
          .post("/api/dragForm/" + list.id, {
            docId: evt.dataTransfer.getData("itemID")
          })
          .then(() => {
            this.getGroups();
            this.getDocuments();
          });

        return console.log("no");
      }
    },

    formDeleted(item, form) {
      window.axios
        .post("/api/formDetached/" + item.id, {
          form: form.id
        })
        .then(() => {
          this.getGroups();
          this.getDocuments();
        });
    },

    groupDeleted(doc, group) {
      window.axios
        .post("/api/groupDetached/" + doc.id, {
          group: group.id
        })
        .then(() => {
          this.getDocuments();
          this.getGroups();
        });
    },

    itemDelete(doc, item) {
      window.axios
        .post("/api/itemDetached/" + doc.id, {
          item: item.id
        })
        .then(() => {
          this.getDocuments();
          this.getGroups();
        });
    },

    getGroups() {
      window.axios.get("/api/getGroups").then(response => {
        this.groups = response.data;
      });
    },

    openModal(item) {
      this.singleGroup = item;
      $("#selectForms").modal("show");
    },

    showMenu(item) {
      this.docSingle = item;
      this.showDialog = true;
    },

    getDocuments() {
      window.axios.get("/api/documents").then(response => {
        this.docs = response.data;
      });
    },

    removeDoc(doc) {
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          window.axios.patch("/api/removeDoc/" + doc.id).then(() => {
            this.getDocuments();
            Swal.fire("Deleted!", "Your Document has been deleted.", "success");
          });
        }
      });
    },

    //@todo text function maybe??
    async getFillable(doc) {
      // Fetch the PDF with form fields
      //const formUrl = this.url + doc.file_name;
      this.submissionName = doc;
      const dataApi = await window.axios.get("/api/docApi/" + doc.id, {
        responseType: "arraybuffer"
      });
      console.log(dataApi.data);

      // //const formUrl = 'https://pdf-lib.js.org/assets/dod_character.pdf';
      // const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer());

      // Load a PDF with form fields
      const pdfDoc = await PDFDocument.load(dataApi.data, {
        ignoreEncryption: true
      });
      // Get the form containing all the fields
      const form = pdfDoc.getForm();
      const nameField = form.getFields();
      console.log(pdfDoc);

      nameField.forEach(field => {
        //console.log(field.constructor.name);

        if (field.constructor.name == "PDFTextField") {
          this.arraySubmission.push({
            type: field.constructor.name,
            name: field.getName(),
            value: field.getText()
          });
        } else if (field.constructor.name == "PDFCheckBox") {
          //console.log(field.isChecked())
          this.arraySubmission.push({
            type: field.constructor.name,
            name: field.getName(),
            value: field.isChecked()
          });
        }

        // if(field.constructor.name == 'PDFTextField'){
        //   value.concat(field.getTextField(field.getName()));
        // }else if(field.constructor.name == 'PDFCheckBox'){
        //    value.concat(field.check());
        // }
      });

      this.arraySub = true;
    },

    closeDialogSub() {
      this.arraySubmission = [];
      this.submissionName = "";
      this.arraySub = false;
    }
  }
};
</script>
